export default "__VITE_ASSET__526c0fea__"